<template>
  <div>
    <el-tabs type="border-card"
             @tab-click="tabclick">
      <el-tab-pane label="账户信息">

      </el-tab-pane>
      <el-tab-pane label="所属省排名">

      </el-tab-pane>
      <el-tab-pane label="所属市排名">

      </el-tab-pane>
      <el-tab-pane label="所属县排名">

      </el-tab-pane>
      <el-tab-pane label="排行榜"
                   name="phb">
      </el-tab-pane>
      <el-tab-pane label="单位标签管理"
                   name="tags">
      </el-tab-pane>
      <el-tab-pane label="审核人员" name='change'> </el-tab-pane>
    </el-tabs>
    <div class="content-wrap">
      <user-info :dwform="dwform"
                 v-show="zhxxisshow"></user-info>
      <tags v-if="currentTab=='tab-tags'" />
      <examinePeople v-if="currentTab=='tab-change'"/>
      <div v-show="tableisshow">
        <div class="header"><export-data :selectdata='tableData'
                       :Field="this.dataField"
                       :dwform='this.dwform'
                       :isout="this.isout"></export-data></div>
        <el-table stripe
                  size='small'
                  :header-cell-style="{background:'#eef1f6',padding:'1px 0px',color:'black'}"
                  style="width: 100%; font-size: 12px; color: black"
                  ref="multipleTable5"
                  :data="tableData"
                  v-loading="loading"
                  element-loading-text="拼命加载中"
                  tooltip-effect="dark"
                  :height="clientHeight">
          <el-table-column type="selection"
                           width="55">
          </el-table-column>
          <el-table-column v-for="(item, index) in currentcloumn.title"
                           :key="index"
                           :prop="currentcloumn.enname[index]"
                           :label="item"
                           :sort-method="(a, b) => {return a[item.props] - b[item.props]}"> </el-table-column>
        </el-table>
      </div>
      <div>
        <phb-table v-show="phpisshow"></phb-table>
      </div>
    </div>
  </div>

</template>

<script>
import phbTable from '@/components/phbTable'
import exportData from '@/components/exportData';
import examinePeople from"@/components/examinePeople.vue"
import userInfo from '@/components/userInfo.vue'
import { getsssb, getssxb, getpro } from '@/utils/request'
import tags from './tags.vue';
export default {
  components: { phbTable, exportData, userInfo, tags,examinePeople },
  data () {
    return {
      loading: false,
      dwform: {},
      currentTab: "",
      currenttable: {},
      name: '',
      city: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["city", "score", "bdqpm"]
      },
      dist: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["dist", "score", "bdqpm"]
      },
      pro: {
        title: ["名称", "总分", "本地区排名"],
        enname: ["region", "score", "bdqpm"]
      },
      tableData: [],
    }
  },
  methods: {
    querycity () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /*       this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getrank&showtype=9&department', {
              params: { "region": this.dwform.region }
            }).then(res => {
              console.log(res.data);
              this.tableData = res.data.data;
              this.tableData.forEach((v, index) => {
                v.bdqpm = index + 1
              })
              this.loading = false;
            }); */
      return getsssb("").then(
        (res) => {
          this.loading = false;
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.bdqpm = index + 1
            })
          }

        },
      )
    },
    querydist () {
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getrank&showtype=10&department', {
        params: { "region": this.dwform.region }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.data;
        this.tableData.forEach((v, index) => {
          v.dist = v.city + "-" + v.dist
          v.bdqpm = index + 1
        });
        this.loading = false;
      }); */
      return getssxb("").then(
        (res) => {
          this.loading = false;
          console.log(res.data);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.dist = v.city + "-" + v.dist
              v.bdqpm = index + 1
            });
          }

        },
      )
    },
    querypro () {
      console.log('请求了数据');
      this.loading = true
      //debugger
      this.tableData = []
      //请求表格数据
      /* this.$http.get('http://192.168.0.177/sajj/gthmmc/index.php?m=ias&c=temp&a=getMemberList', {
        params: { "pageNo": this.currentPage, "pageNum": this.PageSize, "region": this.dwform.region }
      }).then(res => {
        console.log(res.data);
        this.tableData = res.data.datalist;
        this.Count = res.data.total;
        this.loading = false;
      }); */
      return getpro().then(
        (res) => {
          this.loading = false;
          console.log(res);
          this.tableData = res.data.data;
          if (this.tableData !== undefined) {
            this.tableData.forEach((v, index) => {
              v.bdqpm = index + 1
            })
          }
          this.Count = res.data.total;

        },
      )
    },
    tabclick (tab, event) {
      this.currentTab = event.target.getAttribute('id')
      console.log(this.currentPage);
      console.log(this.dataField);
      switch (this.currentTab) {
        case "tab-1":
          this.querypro();
          break
        case "tab-2":
          this.querycity();
          break
        case "tab-3":
          this.querydist();
          break
      }
    },
  },
  created () {
    let that = this;
    that.clientHeight = document.documentElement.clientHeight - 270;
    window.onresize = () => {
      that.clientHeight = document.documentElement.clientHeight - 270;
    }
    this.dwform = JSON.parse(localStorage.getItem('dwform'))
    console.log(this.dwform);
  },
  computed: {
    dataField () {
      switch (this.currentTab) {
        case "tab-1":
          return this.pro
        case "tab-2":
          return this.city
        case "tab-3":
          return this.dist
        default:
          return 0
      }
    },
    zhxxisshow () {
      if (this.currentTab == "" || this.currentTab == "tab-0") {
        return true
      } else {
        return false
      }
    },
    tableisshow () {
      switch (this.currentTab) {
        case "":
          return false
        case "tab-0":
          return false
        case "tab-phb":
          return false
        case "tab-tags":
          return false
          case "tab-change":
          return false
        default:
          return true
      }
    },
    currentcloumn () {
      switch (this.currentTab) {
        case "tab-1":
          return this.pro
        case "tab-2":
          return this.city
        case "tab-3":
          return this.dist
        default:
          return ""
      }
    },
    phpisshow () {
      if (this.currentTab == "tab-phb") {
        return true
      } else {
        return false
      }
    },
    isout () {
      switch (this.currentTab) {
        default:
          return false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.el-table {
  width: 99.9% !important;
}
.content-wrap {
  border: 1px solid #dcdfe6;
  border-top: none;
}
.el-tabs--border-card {
  box-shadow: none !important;
}
</style>